import PropTypes from 'prop-types';
import { ProfileSectionsMap } from '../constants/profileSectionsMap';
import { HelpCentreTopics } from '../constants/helpCentreTopics';

export const FaqsHeadingPropTypes = PropTypes.shape({
  url: PropTypes.string,
  text: PropTypes.string,
  linkText: PropTypes.string,
  linkIcon: PropTypes.string,
  icon: PropTypes.string
});

export const FaqsQuestionPropTypes = PropTypes.shape({
  id: PropTypes.string,
  isPopularQuestion: PropTypes.bool,
  questionId: PropTypes.string,
  questionNo: PropTypes.string,
  response: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string)
});

export const FaqsItemPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired
});

export const FaqsQuestionsPropTypes = PropTypes.arrayOf(FaqsQuestionPropTypes);

export const HelpCentreTopicKeys = Object.keys(HelpCentreTopics);

export const MyProfileTopicKeys = Object.keys(ProfileSectionsMap());

export const TopicsPropType = PropTypes.oneOf([...HelpCentreTopicKeys, ...MyProfileTopicKeys]);
